'use strict';

var index = require('../../../define-properties/index.js');
var index$1 = require('../functions-have-names/index.js');
var polyfill = require('./polyfill.js');

var supportsDescriptors = index.supportsDescriptors;
var functionsHaveNames = index$1();
var getPolyfill = polyfill;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;

var shim = function shimName() {
	var polyfill = getPolyfill();
	if (functionsHaveNames) {
		return polyfill;
	}
	if (!supportsDescriptors) {
		throw new TypeErr('Shimming Function.prototype.name support requires ES5 property descriptor support.');
	}
	var functionProto = Function.prototype;
	defineProperty(functionProto, 'name', {
		configurable: true,
		enumerable: false,
		get: function () {
			var name = polyfill.call(this);
			if (this !== functionProto) {
				defineProperty(this, 'name', {
					configurable: true,
					enumerable: false,
					value: name,
					writable: false
				});
			}
			return name;
		}
	});
	return polyfill;
};

module.exports = shim;
